import React from "react";

import Grid from "@material-ui/core/Grid";

import PanelEventsContainer from "../panel-events-container";
import PanelInstrumentContainer from "../panel-instrument-container";
import PanelTableContainer from "../panel-table-container";
import TrendGraphContainer from "../trend-graph-container";

interface Props {
  nodes?: any[];
  panelCollectionName: string;
  // panelId?: string;
  // panelName: String;
  panelDefinition: any;
}

function SimplePanel(props: Props) {
  const {
    nodes,
    panelCollectionName,
    // panelId,
    // panelName,
    panelDefinition,
  } = props;

  return (
    <Grid container spacing={1} justify="center" alignItems="center">
      <Grid
        item
        xs={6}
        sm={4}
        md={2}
        container
        justify="center"
        alignItems="flex-start"
      >
        <PanelInstrumentContainer
          nodes={nodes}
          panelCollectionName={panelCollectionName}
          panelDefinition={panelDefinition}
        />
      </Grid>
      <Grid item xs={12} md={10}>
        <PanelTableContainer
          nodes={nodes}
          panelCollectionName={panelCollectionName}
          panelDefinition={panelDefinition}
        />
      </Grid>
      <Grid item xs={12}>
        {/* TODO Typography templateDisplayName */}
        <TrendGraphContainer
          nodes={nodes}
          panelCollectionName={panelCollectionName}
          // panelName={panelName}
          panelDefinition={panelDefinition}
          // startDate={moment().startOf("day").unix()}
          // endDate={moment().endOf("day").unix()}
        />
      </Grid>
      <Grid item xs={12}>
        <PanelEventsContainer
          nodes={nodes}
          panelCollectionName={panelCollectionName}
          panelDefinition={panelDefinition}
          // startDate={moment().startOf("day").unix()}
          // endDate={moment().endOf("day").unix()}
        />
      </Grid>
    </Grid>
  );
}

export default SimplePanel;
